import { Navigate, Outlet } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { getPlatformToken } from './config/api.config';

import moment from 'moment'
const PLATFORM_LOGIN_PATH = '/platform/login';

const PlatformProtectedRoute = () => {
  const token = getPlatformToken();
  if (!token) {
    return <Navigate replace to={PLATFORM_LOGIN_PATH} />;
  }
  try {
    const decoded = jwtDecode(token);
    if (decoded.exp && decoded.exp < moment().valueOf() / 1000) {
      return <Navigate replace to={PLATFORM_LOGIN_PATH} />;
    }
    if (decoded.source !== 'platform') {
      return <Navigate replace to={PLATFORM_LOGIN_PATH} />;
    }
    return <Outlet />;
  } catch {
    return <Navigate replace to={PLATFORM_LOGIN_PATH} />;
  }
};

export default PlatformProtectedRoute;
